export default __webpack_public_path__ + "static/media/logo.8d2e1e0c.svg";